<template>
  <!-- 输入昵称对话框 -->
  <div>
    <div class="banner" :style="cover">
      <div class="bgShade">
        <h1 class="banner-title">私人测试</h1>
      </div>
    </div>
    <v-card style="padding: 20px;">
      <v-responsive :aspect-ratio="16 / 9">
        <el-dialog
          class="dialog"
          title="君の蜗"
          :visible.sync="dialogVisible"
          :show-close="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
        >
          <div class="info-table">
            <label style="margin-bottom: 10px; display: inline-block;"
              >输入私密房间号</label
            >
            <el-input
              v-model="roomID"
              maxlength="5"
              placeholder="请输入"
              show-word-limit
              clearable
              type="text"
            />
            <el-button type="primary" @click="confirm" style="margin-top: 20px;"
              >加入房间</el-button
            >
          </div>
        </el-dialog>

        <!-- 主面板 -->
        <div class="main-panel">
          <members
            v-for="user in membersList"
            :id="user.id"
            :name="user.name"
            :key="user.id"
            :socketId="socketId"
            :userinfo="user.userInfo"
          ></members>
        </div>
      </v-responsive>
    </v-card>
  </div>
  <!-- 新版本测试 -->
  <!-- <RouterView /> -->
</template>

<script>
import io from "socket.io-client";
import { Message } from "element-ui";
import members from "./components/members.vue";
export default {
  components: {
    members
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      dialogVisible: true,
      membersList: [],
      otherPeers: new Map(),
      socket: null,
      socketId: null,
      roomID: null,
      localStream: null
    };
  },

  mounted() {
    this.socket = io(process.env.VUE_APP_WEB_RTC, {
      autoConnect: false,
      extraHeaders: {
        Authorization: localStorage.getItem("nodeToken")
      }
    });
    this.socket.on("connect", () => {
      this.socketId = this.socket.id;
      Message({
        message: "连接到服务器",
        type: "success",
        duration: 1000,
        showClose: true
      });
      this.showDelay();
    });

    this.socket.on("connect_error", error => {
      console.error("连接失败:", error.message);
    });

    this.socket.on("disconnect", reason => {
      this.membersList = [];
      this.otherPeers.clear();
      this.dialogVisible = true;
      Message({
        message: "连接已断开",
        type: "error",
        duration: 1000,
        showClose: true
      });
    });

    this.socket.on("joined", (members, { id, name, roomID, userInfo }) => {
      if (id == this.socketId) {
        Message.success("成功加入房间");
        this.dialogVisible = false;
        this.sendOffer(members);
      } else {
        Message.success(name + " 已加入");
        // 给新用户发送 Offer
        this.sendOffer([[id, { name, roomID, userInfo }]]);
      }
    });
    this.socket.on("receive-offer", async (id, sdp) => {
      // 创建 PeerConnection
      const peerConnection = this.createPeerConnection(id);
      // 设置远程描述
      await peerConnection.setRemoteDescription(new RTCSessionDescription(sdp));

      // 创建并设置本地 Answer
      const answer = await peerConnection.createAnswer();
      await peerConnection.setLocalDescription(answer);

      // 发送 Answer 给服务器
      this.socket.emit("send-answer", { id, sdp: answer });
    });
    this.socket.on("send-candidate", (candidate, id) => {
      this.handleSendCandidate(candidate, id);
    });
    this.socket.on("send-disconnect", id => {
      let peerConnection = this.otherPeers.get(id);
      if (peerConnection != null) {
        peerConnection.close();
        Message.warning(this.getNameByID(id) + " 已断开连接");
        this.otherPeers.delete(id);
        this.deleteMembers(id);
      }
    });
    this.socket.on("leave-room", id => {
      // 从otherPeers map中寻找该连接
      let peerConnection = this.otherPeers.get(id);
      if (peerConnection != null) {
        // 若连接存在 关闭连接并从各个表中删除
        peerConnection.close();
        Message.info(`${this.getNameByID(id)}已离开房间`);
        this.otherPeers.delete(id);
        this.deleteMembers(id);
      }
    });
    this.socket.on("delay", msg => {
      let timeTemp = Date.now();
      let timeDelay = timeTemp - msg.time_server;
      // console.warn(msg, { delay: timeDelay, time_client: timeTemp });
      // console.log("server: " + msg.delay + "ms");
      // console.log("local: " + timeDelay + "ms");
      // let delay = (msg.delay + timeDelay) / 2;
      // console.log(delay);
    });

    this.socket.connect();

    // this.confirm();
  },
  methods: {
    async initLocalStream() {
      try {
        // 获取本地媒体流
        this.localStream = await navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: true, // 回声消除
            noiseSuppression: true // 噪音抑制
            // autoGainControl: true // 自动增益控制
          },
          video: true
        });
        console.log("已获取本地媒体流");
        // 预览本地视频
        this.$nextTick(() => {
          const localVideo = document.getElementById(`video${this.socketId}`);
          localVideo.srcObject = this.localStream;
          localVideo.autoplay = true;
          localVideo.muted = true; // 禁止音频播放
        });
      } catch (error) {
        console.error("获取本地媒体流失败", error);
      }
    },
    async sendOffer(members) {
      members.forEach(async element => {
        const [peerId, { name, roomID, userInfo }] = element;
        // 添加成员到列表
        this.addMembers(peerId, name, roomID, userInfo);

        await this.initLocalStream(); // 确保本地流已初始化
        if (peerId !== this.socketId) {
          // 创建 PeerConnection
          const peerConnection = this.createPeerConnection(peerId);

          // 创建 Offer
          const offer = await peerConnection.createOffer();
          await peerConnection.setLocalDescription(offer);

          // 发送 Offer 给服务器
          this.socket.emit("send-offer", { id: peerId, sdp: offer });
          console.log(`发送 Offer 给用户 ${peerId}`);
        }
      });
    },
    createPeerConnection(peerId) {
      let peerConnection = new RTCPeerConnection({
        iceServers: [
          {
            urls: "stun:stun.l.google.com:19302"
          },
          {
            urls: "turn:relay.metered.ca:80",
            username: "your_username",
            credential: "your_credential"
          }
        ]
      });
      // 动态为 PeerConnection 添加音视频轨道
      this.localStream.getTracks().forEach(track => {
        peerConnection.addTrack(track, this.localStream);
      });

      // 监听 ICE 事件
      peerConnection.onicecandidate = event => {
        if (event.candidate) {
          this.socket.emit("send-candidate", {
            candidate: event.candidate,
            id: peerId,
            type: "candidate"
          });
          console.log("已发送 ICE 候选给: " + peerId);
        }
      };

      // 监听远程轨道
      peerConnection.ontrack = event => {
        // let audio = document.getElementById(peerId);
        // audio.autoplay = true;
        // audio.srcObject = event.streams[0];
        let video = document.getElementById("video" + peerId);
        video.autoplay = true;
        video.srcObject = event.streams[0]; // 设置为视频元素的源
      };

      this.otherPeers.set(peerId, peerConnection);
      console.log("已为 " + peerId + " 创建新 PeerConnection");
      return peerConnection;
    },
    // 收到candidate时 若为有效addIceCandidate则add
    async handleSendCandidate(candidate, id) {
      if (this.otherPeers.get(id) && candidate) {
        let peer = this.otherPeers.get(id);
        await peer.addIceCandidate(candidate);
      }
    },
    // 检测延迟
    showDelay() {
      setInterval(() => {
        let time_client = Date.now();
        this.socket.emit("delay", time_client);
      }, 2000);
    },

    // 确认昵称后加入房间
    confirm() {
      if (!this.userInfo?.name) {
        this.$router.push({ path: "/node-login" });
        this.$message.warning("请先重新登录");
        return;
      }
      this.joinRoom(this.roomID, this.userInfo.name, this.userInfo); // 默认加入Room1
    },
    // 加入room 加入成功后会告诉服务器谁来了
    joinRoom(roomId, name, userInfo) {
      this.socket.emit("join-room", { room: roomId, name: name, userInfo });
      Message.info("正在加入房间...");
    },
    // 添加成员
    addMembers(id, name, roomID, userInfo) {
      this.membersList.push({ id, name, roomID, userInfo });
    },
    // 删除成员
    deleteMembers(id) {
      this.membersList = this.membersList.filter(info => info.id !== id);
    },
    // 根据id查找用户名
    getNameByID(id) {
      let usrname = this.membersList.filter(info => info.id == id);
      return usrname[0].name;
    }
  },
  beforeDestroy() {
    this.socket.disconnect();
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach(item => {
        if (item.pageLabel === "about") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    }
  }
};
</script>

<style scoped>
.main-panel {
  height: 100vh;
  width: 100vw;
  padding: 2rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow-y: auto;
  /* align-content: flex-start; */
  /* justify-items: center; */
}
</style>
